import {BRAILLER_QUEUE_STATUS} from "./braillerQueueFactory";
import {checkAndSetError, clearInputFormErrorFields, inputFormIsValid} from "../../../../Components/Inputs";

export const filterQueueByStatus = (queue: Record<string, any>[], isPending: boolean) => {
    if (!queue || queue.length === 0) return [];

    return isPending
        ? queue.filter((q: Record<string, any>) =>
            q.status === BRAILLER_QUEUE_STATUS.Pending ||
            q.status === BRAILLER_QUEUE_STATUS.Waitlist
        )
        : queue.filter((q: Record<string, any>) =>
            q.status === BRAILLER_QUEUE_STATUS.ReadyForProcessing ||
            q.status === BRAILLER_QUEUE_STATUS.WaitlistProcessing
        );
};

export const getAllDuplicateCatalogItemsForStudent = (formData: Record<string, any>, pendingQueue: Record<string, any>[], processingQueue: Record<string, any>[]) => {
    const selectedPendingItems = pendingQueue.filter((item: Record<string, unknown>) =>
        formData.braillerQueueItemIds.includes(String(item.braillerQueueId))
    );

    const duplicates = selectedPendingItems.filter((pendingItem: Record<string, any>) =>
        processingQueue.some((processingItem: Record<string, any>) =>
            processingItem.braillerCatalogItemId === pendingItem.braillerCatalogItemId
        )
    );

    return duplicates;
};

export const createConfirmationMessageForDuplicates = (duplicates: Record<string, any>[], hasDuplicates: boolean) => {
    if (!hasDuplicates) return "";

    const duplicateTitles = duplicates.map((d: Record<string, any>) => `"${d.title}"`).join(", ");

    return `The following items are already being processed: ${duplicateTitles}. ` +
        `Are you sure you want to assign duplicates?`;
};

export function isBraillerQueueFormValid(queueForm: Record<string, any>) {
    clearInputFormErrorFields(queueForm);
    checkAndSetError([
        queueForm.studentId,
        queueForm.shippingLocationId,
    ]);

    return inputFormIsValid(queueForm);
}